import { formatLargeCurrency } from "./utilities";

//This function will always be contained within a promise, hence the resolve
export function getVolatilityResults(resolve, startAmount) {
    //Calculate the necessary numbers for building graphs
    function volatilityCalc(data, startAmount) {
        //Get an easy-to-use object from the data, with numbers in the correct type
        const dataset = JSON.parse(data.responseText).dataset.map((dataUnit) => {
            return {
                date: dataUnit.date,
                rate: Number(dataUnit.rate)
            };
        });

        //Calculate 30 highest rates
        const highest30Array = dataset.sort((a, b) => (a.rate < b.rate ? 1 : -1)).slice(0, 30);

        let continuousAmount = startAmount;
        let missing10 = startAmount;
        let missing20 = startAmount;
        let missing30 = startAmount;

        // Calculate the returns over the years
        for (let i = 0; i < dataset.length; i++) {
            const date = dataset[i].date;

            let highest10, highest20, highest30;

            // Detect if date is in the best 10, 20 or 30 days of the ten year period
            for (let j = 0; j < highest30Array.length; j++) {
                if (date === highest30Array[j].date) {
                    if (j < 10) {
                        highest10 = true;
                    }
                    if (j < 20) {
                        highest20 = true;
                    }

                    highest30 = true;
                }
            }

            //Calculate amount for continuous investment
            continuousAmount = continuousAmount * dataset[i].rate + continuousAmount;
            //If date is included in the highest 10, 20, or 30 days of ten year period, skip that day in calculation
            missing10 = highest10 ? missing10 : missing10 * dataset[i].rate + missing10;
            missing20 = highest20 ? missing20 : missing20 * dataset[i].rate + missing20;
            missing30 = highest30 ? missing30 : missing30 * dataset[i].rate + missing30;
        }

        //Send back results to promise inside resolve()
        resolve({
            stack4: continuousAmount,
            stack3: missing10,
            stack2: missing20,
            stack1: missing30
        });
    }

    //Make call to json data
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            //Call the calculation function - we will change the second argument (startAmount) to a variable when input is set up in HTML
            volatilityCalc(this, startAmount);
        }
    };
    xhttp.open("GET", "./common/data/data.json", true);
    xhttp.send();
}

export function getYAxisValues(highestVal) {
    const maxValue = Number(((40 / 35) * highestVal).toFixed(0)); // Ratio is roughly equivalent to design
    const ticks = {
        max: maxValue,
        quarter: maxValue * 0.25,
        half: maxValue * 0.5,
        threeQuarter: maxValue * 0.75,
        zero: 0
    };

    for (let tick in ticks) {
        ticks[tick] = formatLargeCurrency(ticks[tick]);
    }

    return ticks;
}
